// react
import { ROUTES } from 'router';
import { useCallback, useState } from 'react';
import { useGoBack } from 'hooks/useGoBack';

// store
import { useDispatch } from 'react-redux';
import { newToast } from 'store/slices/uiSlice';

// components
import AttendanceAllowanceSuccessPage from '@karehero/llama/components/pages/AttendanceAllowanceSuccess/AttendanceAllowanceSuccess';

// hooks
import { useCareProfile } from 'hooks';
import { generatePdf } from 'pdf/attendanceAllowance';
import { CareProfileCategoryID } from '@karehero/models';

/**
 * AttendanceAllowanceSuccess is the page displayed when the user has successfully submitted the Attendance Allowance form.
 */
export const AttendanceAllowanceSuccess = () => {
  // hooks
  const goBack = useGoBack();
  const dispatch = useDispatch();

  const { careRecipientFirstName, careProfileID } = useCareProfile({
    categoryID: CareProfileCategoryID.CareAssessment,
  });

  const [isDownloading, setIsDownloading] = useState(false);

  // methods
  const handlePrintPdf = useCallback(async () => {
    if (!careProfileID || isDownloading) return;

    setIsDownloading(true);
    try {
      await generatePdf(careProfileID);
    } catch {
      dispatch(
        newToast({
          title: 'Failed to download form',
          description:
            'Please try again. If the problem persists, contact support.',
          variant: 'error',
        }),
      );
    } finally {
      setIsDownloading(false);
    }
  }, [careProfileID, isDownloading, dispatch]);

  return (
    <AttendanceAllowanceSuccessPage
      onBack={goBack}
      handlePrintPdf={handlePrintPdf}
      isDownloading={isDownloading}
      name={careRecipientFirstName ?? 'Your Loved One'}
    />
  );
};

export default AttendanceAllowanceSuccess;
